import Home from "./pages/Home.vue";
import About from "./pages/About.vue";
import Page from "./pages/Page.vue";
import Dashboard from "./pages/admin/Dashboard.vue";
import Series from "./pages/admin/series/Series.vue";
import AdminWrapper from "./pages/admin/AdminWrapper.vue";
import SeriesEdit from "./pages/admin/series/SeriesEdit.vue";
import SeriesShow from "./pages/admin/series/SeriesShow.vue";
import SeriesCreate from "./pages/admin/series/SeriesCreate.vue";
import Languages from "./pages/admin/languages/Languages.vue";
import LanguageCreate from "./pages/admin/languages/LanguageCreate.vue";
import LanguageEdit from "./pages/admin/languages/LanguageEdit.vue";
import CategoryEdit from "./pages/admin/categories/CategoryEdit.vue";
import CategoryCreate from "./pages/admin/categories/CategoryCreate.vue";
import Categories from "./pages/admin/categories/Categories.vue";
import Media from "./pages/admin/media/Media.vue";
import MediaCreate from "./pages/admin/media/MediaCreate.vue";
import MediaEdit from "./pages/admin/media/MediaEdit.vue";
import Assets from "./pages/admin/assets/Assets.vue";
import AssetCreate from "./pages/admin/assets/AssetCreate.vue";
import AssetEdit from "./pages/admin/assets/AssetEdit.vue";
import ArabicAssets from "./pages/admin/arabic-assets/ArabicAssets.vue";
import ArabicAssetCreate from "./pages/admin/arabic-assets/ArabicAssetCreate.vue";
import ArabicAssetEdit from "./pages/admin/arabic-assets/ArabicAssetEdit.vue";
import Pages from "./pages/admin/pages/Pages.vue";
import PageCreate from "./pages/admin/pages/PageCreate.vue";
import PageEdit from "./pages/admin/pages/PageEdit.vue";
import Material from "./pages/Material.vue";
import Endorsements from "./pages/Endorsements.vue";
import Contact from "./pages/Contact.vue";
import SubscriberHome from "./pages/subscribers/SubscriberHome.vue";
import MaterialLanguages from "./pages/MaterialLanguages.vue";
import SubscriberSeries from "./pages/subscribers/SubscriberSeries.vue";
import UserEdit from "./pages/admin/users/UserEdit.vue";
import Users from "./pages/admin/users/Users.vue";
import LessonEdit from "./pages/admin/lessons/LessonEdit.vue";
import LessonShow from "./pages/admin/lessons/LessonShow.vue";
import ComponentEdit from "./pages/admin/components/ComponentEdit.vue";
import ComponentShow from "./pages/admin/components/ComponentShow.vue";
import ComponentCreate from "./pages/admin/components/ComponentCreate.vue";
import TranslationEdit from "./pages/admin/translations/TranslationEdit.vue";
import TranslationCreate from "./pages/admin/translations/TranslationCreate.vue";
import Lesson from "./pages/subscribers/Lesson.vue";
import Abraham from "./pages/Abraham.vue";
import Beginnings from "./pages/Beginnings.vue";
import Colossians from "./pages/Colossians.vue";
import David from "./pages/David.vue";
import Elijah from "./pages/Elijah.vue";
import Esther from "./pages/Esther.vue";
import Exodus from "./pages/Exodus.vue";
import Jacob from "./pages/Jacob.vue";
import Job from "./pages/Job.vue";
import John from "./pages/John.vue";
import Jonah from "./pages/Jonah.vue";
import Joseph from "./pages/Joseph.vue";
import Joshua from "./pages/Joshua.vue";
import Judges from "./pages/Judges.vue";
import Lost from "./pages/Lost.vue";
import Luke from "./pages/Luke.vue";
import MissionUnstoppable from "./pages/MissionUnstoppable.vue";
import ParablesOfTheKingdom from "./pages/ParablesOfTheKingdom.vue";
import Psalms from "./pages/Psalms.vue";
import Ruth from "./pages/Ruth.vue";
import Samuel from "./pages/Samuel.vue";
import Saul from "./pages/Saul.vue";
import Solomon from "./pages/Solomon.vue";
import CookiePolicy from "./pages/CookiePolicy.vue";
import LicenseAgreement from "./pages/LicenseAgreement.vue";
import PrivacyPolicy from "./pages/PrivacyPolicy.vue";
import StatementOfFaith from "./pages/StatementOfFaith.vue";
import Arabic from "./pages/Arabic.vue";
import LessonCreate from "./pages/admin/lessons/LessonCreate.vue";
import Samples from "./pages/Samples.vue";

const routes = [
    {
        path: "/",
        name: "home",
        component: Home,
    },
    {
        path: "/about",
        name: "about",
        component: About,
    },
    {
        path: "/material",
        name: "material",
        component: Material,
    },
    {
        path: "/samples",
        name: "samples",
        component: Samples,
    },
    {
        path: "/endorsements",
        name: "endorsements",
        component: Endorsements,
    },
    {
        path: "/contact",
        name: "contact",
        component: Contact,
    },
    {
        path: "/languages",
        name: "languages",
        component: MaterialLanguages,
    },
    {
        path: "/cookie-policy",
        name: "cookie-policy",
        component: CookiePolicy,
    },
    {
        path: "/license-agreement",
        name: "license-agreement",
        component: LicenseAgreement,
    },
    {
        path: "/privacy-policy",
        name: "privacy-policy",
        component: PrivacyPolicy,
    },
    {
        path: "/statement-of-faith",
        name: "statement-of-faith",
        component: StatementOfFaith,
    },

    // subscribers
    {
        path: "/home",
        component: SubscriberHome,
    },
    {
        path: "/series/:id",
        component: SubscriberSeries,
    },

    // viewers
    {
        path: "/lessons/:id",
        component: Lesson,
    },

    // subscribers
    {
        path: "/arabic",
        component: Arabic,
    },

    // admin
    {
        path: "/dashboard",
        redirect: "/admin",
    },
    {
        path: "/admin",
        component: AdminWrapper,
        beforeEnter: () => (window.app.canAdministrate || window.app.canTranslate),
        children: [
            // admin - dashboard
            {
                path: "",
                component: Dashboard,
            },

            // admin - series
            {
                path: "series",
                component: Series,
                beforeEnter: () => (window.app.canAdministrate || window.app.canTranslate),
            },
            {
                path: "series/create",
                component: SeriesCreate,
                beforeEnter: () => window.app.canAdministrate,
            },
            {
                path: "series/:id",
                component: SeriesShow,
                beforeEnter: () => (window.app.canAdministrate || window.app.canTranslate),
            },
            {
                path: "series/:id/edit",
                component: SeriesEdit,
                beforeEnter: () => window.app.canAdministrate,
            },

            // admin - lessons
            {
                path: "lessons/:id",
                component: LessonShow,
                beforeEnter: () => (window.app.canAdministrate || window.app.canTranslate),
            },
            {
                path: "lessons/create",
                component: LessonCreate,
                beforeEnter: () => window.app.canAdministrate,
            },
            {
                path: "lessons/:id/edit",
                component: LessonEdit,
                beforeEnter: () => window.app.canAdministrate,
            },

            // admin - translations
            {
                path: "translations/create",
                component: TranslationCreate,
                beforeEnter: () => (window.app.canAdministrate || window.app.canTranslate),
            },
            {
                path: "translations/:id/edit",
                component: TranslationEdit,
                beforeEnter: () => (window.app.canAdministrate || window.app.canTranslate),
            },

            // admin - components
            {
                path: "components/create",
                component: ComponentCreate,
                beforeEnter: () => window.app.canAdministrate,
            },
            {
                path: "components/:id",
                component: ComponentShow,
                beforeEnter: () => (window.app.canAdministrate || window.app.canTranslate),
            },
            {
                path: "components/:id/edit",
                component: ComponentEdit,
                beforeEnter: () => window.app.canAdministrate,
            },

            // admin - users
            {
                path: "users",
                component: Users,
                beforeEnter: () => window.app.canAdministrate,
            },
            {
                path: "users/:id/edit",
                component: UserEdit,
                beforeEnter: () => window.app.canAdministrate,
            },

            // admin - languages
            {
                path: "languages",
                component: Languages,
                beforeEnter: () => window.app.canAdministrate,
            },
            {
                path: "languages/create",
                component: LanguageCreate,
                beforeEnter: () => window.app.canAdministrate,
            },
            {
                path: "languages/:id/edit",
                component: LanguageEdit,
                beforeEnter: () => window.app.canAdministrate,
            },

            // admin - categories
            {
                path: "categories",
                component: Categories,
                beforeEnter: () => window.app.canAdministrate,
            },
            {
                path: "categories/create",
                component: CategoryCreate,
                beforeEnter: () => window.app.canAdministrate,
            },
            {
                path: "categories/:id/edit",
                component: CategoryEdit,
                beforeEnter: () => window.app.canAdministrate,
            },

            // admin - media
            {
                path: "media",
                component: Media,
                beforeEnter: () => window.app.canAdministrate,
            },
            {
                path: "media/create",
                component: MediaCreate,
                beforeEnter: () => window.app.canAdministrate,
            },
            {
                path: "media/:id/edit",
                component: MediaEdit,
                beforeEnter: () => window.app.canAdministrate,
            },

            // admin - assets
            {
                path: "assets",
                component: Assets,
                beforeEnter: () => window.app.canAdministrate,
            },
            {
                path: "assets/create",
                component: AssetCreate,
                beforeEnter: () => window.app.canAdministrate,
            },
            {
                path: "assets/:id/edit",
                component: AssetEdit,
                beforeEnter: () => window.app.canAdministrate,
            },

            // admin - arabic assets
            {
                path: "arabic-assets",
                component: ArabicAssets,
                beforeEnter: () => window.app.canAdministrate,
            },
            {
                path: "arabic-assets/create",
                component: ArabicAssetCreate,
                beforeEnter: () => window.app.canAdministrate,
            },
            {
                path: "arabic-assets/:id/edit",
                component: ArabicAssetEdit,
                beforeEnter: () => window.app.canAdministrate,
            },

            // admin - pages
            {
                path: "pages",
                component: Pages,
                beforeEnter: () => window.app.canAdministrate,
            },
            {
                path: "pages/create",
                component: PageCreate,
                beforeEnter: () => window.app.canAdministrate,
            },
            {
                path: "pages/:id/edit",
                component: PageEdit,
                beforeEnter: () => window.app.canAdministrate,
            },
        ],
    },

    // SEO pages
    {
        path: "/abraham",
        component: Abraham,
    },
    {
        path: "/beginnings",
        component: Beginnings,
    },
    {
        path: "/colossians",
        component: Colossians,
    },
    {
        path: "/david",
        component: David,
    },
    {
        path: "/elijah",
        component: Elijah,
    },
    {
        path: "/esther",
        component: Esther,
    },
    {
        path: "/exodus",
        component: Exodus,
    },
    {
        path: "/jacob",
        component: Jacob,
    },
    {
        path: "/job",
        component: Job,
    },
    {
        path: "/john",
        component: John,
    },
    {
        path: "/Jonah",
        component: Jonah,
    },
    {
        path: "/joseph",
        component: Joseph,
    },
    {
        path: "/joshua",
        component: Joshua,
    },
    {
        path: "/judges",
        component: Judges,
    },
    {
        path: "/lost",
        component: Lost,
    },
    {
        path: "/lukes-first-easter",
        component: Luke,
    },
    {
        path: "/mission-unstoppable",
        component: MissionUnstoppable,
    },
    {
        path: "/parables-of-the-kingdom",
        component: ParablesOfTheKingdom,
    },
    {
        path: "/psalms",
        component: Psalms,
    },
    {
        path: "/ruth",
        component: Ruth,
    },
    {
        path: "/samuel",
        component: Samuel,
    },
    {
        path: "/saul",
        component: Saul,
    },
    {
        path: "/solomon",
        component: Solomon,
    },

    // CMS page
    {
        path: '/:pathMatch(.*)*',
        component: Page,
    },
];

export default routes;
